export const fetcher = async (url, action, params = "") =>
	fetch(`${url}?action=${action}&${params}`).then((res) => res.json());

export const pageFetcher = (url, action, perPage, page, params = "") =>
	fetcher(url, action, `per_page=${perPage}&page=${page}&${params}`);
